//
//
//
//
//

export default {
  props: {
    name: { type: String, required: true },
    sku: { type: String, required: true },
    description: { type: String, required: true },
    baseSku: { type: String, required: true },
    price: { type: Number, required: true }
  },
  computed: {
    reviewSummary () {
      return this.$store.getters['review/productSummary'](this.baseSku)
    },
    review () {
      return this.$store.getters['review/productReviews'](this.baseSku, 1)[0] || { review_body: '' }
    },
    reviewBody () {
      if (this.review.review_body.startsWith('B64:')) {
        return this.b64DecodeUnicode(this.review.review_body.split(':')[1])
      }
      return this.review.review_body
    },
    rating () {
      return this.reviewSummary.rating
    },
    count () {
      return this.reviewSummary.count
    },
    schema () {
      const schema = {
        '@context': 'https://schema.org',
        '@type': 'Product',
        name: this.name,
        image: `https://dynamic.sungod.co/herodynamic/${this.sku}.800.0.png`,
        description: this.$tr(this.description),
        sku: this.sku,
        mpn: this.sku,
        brand: {
          '@type': 'Thing',
          name: 'SunGod'
        },
        offers: {
          '@type': 'Offer',
          url: `https://www.sungod.co/${this.$route.fullPath}`,
          priceCurrency: 'GBP',
          priceValidUntil: '2030-01-01',
          price: this.price,
          itemCondition: 'https://schema.org/NewCondition',
          availability: 'https://schema.org/InStock',
          seller: {
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: 'SunGod',
            url: 'https://www.sungod.co/',
            sameAs: [
              'https://www.facebook.com/sungodsunglasses',
              'https://www.instagram.com/we_are_sungod'
            ]
          }
        }
      }

      if (this.count) {
        schema.aggregateRating = {
          '@type': 'AggregateRating',
          ratingValue: this.rating,
          reviewCount: this.count
        }
      }

      if (this.reviewBody) {
        schema.review = {
          '@type': 'Review',
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '5',
            bestRating: '5'
          },
          reviewBody: this.reviewBody,
          author: {
            '@type': 'Person',
            name: this.review.name
          }
        }
      }

      return schema
    }
  }
}
